import { MutableRefObject, useEffect, useMemo } from "react";
import { ICustomScrollStore } from "../../_store/CustomScrollStoreModel";
import { setDimensionsAction } from "../setOffsetsOnScroll/setOffsetsOnScrollActions";
import { buildEffectWithElementHook } from "../../_shared/elementForFeatureHook";
import { buildListenerOnDiff } from "../../_store/customScrollStoreDomain";
import {
    IPerfectScrollExtensions,
    IPerfectScrollState,
} from "../../scroll/perfectScrollModel";
import { bindEvent } from "../../_utils/domElementEventHelpers";
import { getScrollContainerProps } from "../../_shared/scrollOffsetDomain";
import { useCustomScrollObjectSelector } from "../../_store/customScrollSelectorHook";
import { optionsSelector } from "../../_shared/optionsSelector";
import { noopFn } from "../../_utils/fnUtils";

/*
 */
export function useRecalculateDimensionsOnResize(
    containerRef: MutableRefObject<HTMLElement>,
    store: ICustomScrollStore,
    extensions: IPerfectScrollExtensions
) {
    const bound = useMemo(
        () => onResize.bind(null, containerRef, store, extensions),
        [extensions?.getScrollContainerProps]
    );
    const options = useCustomScrollObjectSelector(optionsSelector, { store });

    useEffect(
        () =>
            options?.useAnimationFrame
                ? noopFn
                : bindEvent(window, "resize", bound),
        [bound, options?.useAnimationFrame]
    );
}

/*
 */
export const useRecalculateDimensionsOnInternalChange = buildEffectWithElementHook(
    (current, store, extensions) =>
        buildListenerOnDiff(
            store,
            selectInnerChangeTick,
            onResize.bind(null, { current }, store, extensions)
        )
);

const selectInnerChangeTick = (s: IPerfectScrollState) => ({
    s: s.status?.innerChangeTick,
});

//
function onResize(
    containerRef: MutableRefObject<HTMLElement>,
    store: ICustomScrollStore,
    extensions: IPerfectScrollExtensions
) {
    const element = containerRef.current;
    element &&
        store.dispatch(
            setDimensionsAction(
                getScrollContainerProps(
                    element,
                    extensions?.getScrollContainerProps
                )
            )
        );
}
